'use strict';

var _ = require('lodash');
var angular = require('angular');
var KpiRibbonDirective = function KpiRibbonDirective(kpiRibbonService) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/kpi-ribbon.html'),
    controller: 'KpiRibbonController',
    scope: {
      mode: '@',
      postDepartureModeName: '=?',
      screen: '@',
      startCollapsed: '=?',
      showKpiTarget: '=?',
      canRetrieveData: '=',
      screenState: '=',
      secondaryData: '='
    },
    link: function link(scope) {
      var toggleContainer;
      scope.isCollapsed = false;
      if (_.isUndefined(scope.startCollapsed)) {
        scope.startCollapsed = false;
      }
      scope.generateKpiItems({});
      scope.$on('search-criteria:searchChangeEvent', scope.retrieveData);
      scope.$on('brush-filter:filterApplied', scope.retrieveData);
      scope.$watch('screenState.selectedReference', function () {
        if (_.get(scope, ['screenState', 'searchReady'])) {
          scope.retrieveData();
        }
      });
      scope.formatMetric = function (metric, value, type) {
        return scope.loadingMetrics ? null : kpiRibbonService.formatMetric(metric, value, type);
      };
      scope.toggleKpiItemCollapsed = function (item) {
        if (item.collapsable) {
          item.collapsed = !item.collapsed;
          scope.$emit('reload-carousel');
        }
      };
      scope.setClass = function (item) {
        var result = '';
        // get visible items
        var visibleItemsLength = _.filter(item.metrics, {
          hidden: false
        }).length;
        if (!item.collapsed && visibleItemsLength === 1) {
          result += 'small';
        } else if (!item.collapsed && visibleItemsLength === 2) {
          result += 'medium';
        } else if (!item.collapsed && visibleItemsLength === 3 || item.collapsed && item.collapsable) {
          result += 'large';
        }
        result = item.collapsable ? result + ' kpi-item-collapsible' : result;
        return result;
      };
      scope.$watch('startCollapsed', function (newValue) {
        if (newValue !== scope.isCollapsed) {
          scope.invokeCollapse();
        }
      });
      scope.invokeCollapse = function () {
        toggleContainer = toggleContainer || angular.element('#' + scope.uniqueId);
        toggleContainer.collapse('toggle');
        if (scope.isCollapsed) {
          scope.isCollapsed = false;
          scope.startCollapsed = false;
          scope.retrieveData();
        } else {
          scope.isCollapsed = true;
          scope.startCollapsed = true;
        }
      };
    }
  };
};
KpiRibbonDirective.$inject = ['KpiRibbonService'];
module.exports = KpiRibbonDirective;